export default __webpack_public_path__ + "static/media/rihanna_cover.03b201a0.jpg";